import request from '@/router/axios';
/**
 * 代账数据分析
 */
export const chargesStatisticsList = (params) =>request.get('/api/cube-agent/charges_statistics/list',{params})
/**
 * 获取合同签约统计
 */
export const contractAward = (params) =>request.get('/api/cube-agent/charges_statistics/contract_award',{params})
/**
 * 获取合同签约统计
 */
 export const copyCollection = (params) =>request.get('/api/cube-agent/charges_statistics/copy_collection',{params})
 /**
  * 获取战队信息
  */
 export const getdept = (params) =>request.get('/api/cube-agent/charges_statistics/getdept',{params})

 /**
  * 获取需签约客户列表分页列表
  */
  export const getXSignedCompanyList = (params) =>request.get('/api/cube-agent/charges_statistics/getXSignedCompanyList',{params})


export const deptkzsxSubmit = (row) => {
  return request({
    url: '/api/cube-agent/deptkzsx/submit',
    method: 'post',
    data: row
  })
}
